'use client'

import { FC, ReactNode, useState } from 'react'
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { logSentryError } from '@/utils/helpers'

export const ReactQueryClientProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: (error, queryKey) =>
            logSentryError(`React Query query with ${queryKey} error`, error),
        }),
        mutationCache: new MutationCache({
          onError: (error, queryKey) =>
            logSentryError(`React Query mutation with with ${queryKey} error`, error),
        }),
      })
  )

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
